export function actionLogAdd(action, value) {
	return {
    type: 'ACTION_LOG_ADD',
    payload: {
      action: action,
      value: value,
		},
	}
};
